import { useEffect, useRef, useState } from "react";
import SelectedArrayContainer from "./ControllableMediaArray/SelectedArrayContainer";
import "./ControllableOutput.css";

import SocialOperator from ".";
import SuperScreen from "../../SuperScreen";
import SavedLayouts from "../../SuperScreen/SavedLayouts";
import { getNewSockeInstance } from "../../../socket";
const ControllableOutput = (props) => {
  const socket = useRef(getNewSockeInstance()).current;
  const { event, loggedInUser } = props;
  const wrapperRef = useRef(null);
  const superScreenRef = useRef(null);
  const controllableColumnRef = useRef(null);

  const [zoom, setZoom] = useState(1);
  const [monitorZoom, setMonitorZoom] = useState(1);
  const getZoomOutFactor = () => {
    if (!wrapperRef.current) {
      return 1;
    }
    const width = wrapperRef.current.getBoundingClientRect().width;
    const height = wrapperRef.current.getBoundingClientRect().height;
    return Math.max(width / zoom / 1920, height / zoom / 1080);
  };
  useEffect(() => {
    socket.connect();
    const handleResize = () => {
      setZoom(Math.max(window.innerWidth / 1920, window.innerHeight / 1080));
      if (monitorZoom === 1) {
        setMonitorZoom(getZoomOutFactor());
      }
    };

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Call handler once to set initial size
    handleResize();
    setMonitorZoom(getZoomOutFactor());
    return () => {
      socket.disconnect();
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    setMonitorZoom(getZoomOutFactor());
  }, [zoom]);

  return (
    <div className="controllable-output-container" style={{ zoom }}>
      <div className="co-media-array">
        <div
          className="grab-area grey-box"
          id="social-operator-in-controllable"
        >
          <SocialOperator
            forceRerender={props.forceRerender}
            draggableMedia={true}
            controllable={true}
          />
        </div>

        <div className="monitor">
          <div className="co-preview-monitor" ref={wrapperRef}>
            <div className="zoomed-out-container" style={{ zoom: monitorZoom }}>
              <SuperScreen
                noIframe={true}
                eventId={event._id}
                ref={superScreenRef}
              />
            </div>
          </div>
          <SavedLayouts
            eventId={event._id}
            onLayoutChange={(layout) => {
              superScreenRef.current?.triggerOnlayoutChange(layout);
            }}
            selected={1}
            isReadOnly={true}
            isControllable={true}
          />
        </div>
      </div>
      <div className="co-bottom">
        <div className="media-collection grey-box">
          {loggedInUser && (
            <SelectedArrayContainer
              eventId={event._id}
              loggedInUser={loggedInUser}
              socket={socket}
            />
          )}
        </div>
      </div>
    </div>
  );
};
export default ControllableOutput;
